import { render } from "./AddApropos.vue?vue&type=template&id=e0af8980&ts=true"
import script from "./AddApropos.vue?vue&type=script&lang=ts"
export * from "./AddApropos.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__